import React, { FC } from 'react';
import circle from 'assets/img/icon-circle.svg';
import checked from 'assets/img/icon-check.svg';
import unchecked from 'assets/img/icon-uncheck.svg'
import * as S from './styles';
import { ValidationObj } from 'components/NewPassInput';
interface ValidationInfoProps {
  validation: ValidationObj | undefined;
  responsive?: boolean;
}

const ValidationInfo: FC<ValidationInfoProps> = ({ validation, responsive }) => {

  const returnIcon = (condition) => {
    if (condition === undefined) {
      return circle;
    } else if (condition) {
      return checked;
    }
    return unchecked;
  };

  return (
    <S.ValidationContainer responsive={responsive}>
      <S.ValidationTitle>Sua senha deve conter:</S.ValidationTitle>
      <S.DivStyled>
        <S.Icon src={returnIcon(validation?.hasCorrectLength)} />
        <S.ValidationText>
          Mínimo de 10 caracteres
        </S.ValidationText>
      </S.DivStyled>
      <S.DivStyled>
        <S.Icon src={returnIcon(validation?.hasLowerCase)} />
        <S.ValidationText>
          Uma letra minúscula
        </S.ValidationText>
      </S.DivStyled>
      <S.DivStyled>
        <S.Icon src={returnIcon(validation?.hasUpperCase)} />
        <S.ValidationText>
          Uma letra maiúscula
        </S.ValidationText>
      </S.DivStyled>
      <S.DivStyled>
        <S.Icon src={returnIcon(validation?.hasNumber)} />
        <S.ValidationText>
          Um número
        </S.ValidationText>
      </S.DivStyled>
      <S.DivStyled>
        <S.Icon src={returnIcon(validation?.hasSpecialChar)} />
        <S.ValidationText>
          {"Um caractere especial (!”#$%&'()*+,-./:;<=>?@[]^_`{|}~)"}
        </S.ValidationText>
      </S.DivStyled>
      <S.DivStyled>
        <S.Icon src={returnIcon(validation?.hasNoSpecialCharacterAtBeginning)} />
        <S.ValidationText>
          Primeiro dígito diferente de caractere especial
        </S.ValidationText>
      </S.DivStyled>
    </S.ValidationContainer>
  );
};

export default ValidationInfo;
